// @ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { MODEL_ICONS } from '../lib/ModelIcons';

const ModelSelector = ({
  selectedModel,
  setSelectedModel,
  models,
  providerIconIndexMapping,
  isModelSelecting,
  currentModelIcon,
  theme,
  isLoading,
  handleModelAutoSelect,
}) => {
  const bgColor =
    theme === 'light'
      ? 'bg-white text-black border-gray-300'
      : 'bg-gray-900 text-white border-gray-700';
  const hoverBgColor =
    theme === 'light' ? 'hover:bg-gray-200' : 'hover:bg-gray-700';
  const hoverTextColor =
    theme === 'light' ? 'hover:text-black' : 'hover:text-black';
  const triggerHoverBgColor =
    theme === 'light' ? 'hover:bg-gray-300' : 'hover:bg-gray-700';
  const triggerHoverTextColor =
    theme === 'light' ? 'hover:text-black' : 'hover:text-black';

  return (
    <>
      <button
        type="button"
        onClick={handleModelAutoSelect}
        title="Auto-select Best Model"
        style={{
          position: 'relative',
          zIndex: 2,
          background: 'none',
          border: 'none',
          padding: '8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          marginRight: '2px',
          overflow: 'hidden',
        }}
        className={isModelSelecting ? 'model-selecting' : ''}
      >
        {isModelSelecting ? (
          <div
            className="model-icon-animation"
            style={{
              width: '24px',
              height: '24px',
            }}
          >
            {MODEL_ICONS[currentModelIcon]}
          </div>
        ) : (
          <svg
            fill="#a8a8a8"
            viewBox="0 0 52 52"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#a8a8a8"
            width="24"
            height="24"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M31.9981689,11.9995104 C33.4659424,11.9985117 34.998291,13.1328 34.998291,16.1348 L34.998291,16.1348 L34.998291,26 C34.998291,27.5134277 36.3779053,28.1114014 36.9779053,28.3114014 L36.9779053,28.3114014 L43.8,30.8 C46.7,31.9 48.5,35 47.7,38.2 L47.7,38.2 L44.5,48.5995 C44.3,49.3995 43.6,49.9995 42.7,49.9995 L42.7,49.9995 L26.6,49.9995 C25.8,49.9995 25.1,49.5995 24.8,48.8995 C20.9318685,39.9190553 18.7869873,34.9395752 18.3653564,33.9610596 C17.9437256,32.9825439 18.2219401,32.1955241 19.2,31.6 C21,30.3 23.7,31.6395508 24.8,33.5395508 L24.8,33.5395508 L26.4157715,35.7431828 C27.0515137,36.9508 29,36.9508 29,35.1508 L29,35.1508 L29,16.1348 C29,13.1328 30.5303955,12.0005117 31.9981689,11.9995104 Z M46,2 C48.2,2 50,3.8 50,6 L50,6 L50,21 C50,22.882323 48.1813389,25.0030348 46,25 L46,25 L40.010437,25 C39,25 39,24.1881157 39,24.059082 L39,15.5 C39,11.6547018 37.0187988,8 32,8 C26.9812012,8 25,11.1879783 25,15.5 L25,15.5 L25,24.059082 C25,24.4078007 24.7352295,25 23.987793,25 L23.987793,25 L6,25 C3.8,25 2,23.2 2,21 L2,21 L2,6 C2,3.8 3.8,2 6,2 L6,2 Z"></path>
            </g>
          </svg>
        )}
      </button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            disabled={isLoading}
            className={`relative z-2 border ${bgColor} ${triggerHoverBgColor} ${triggerHoverTextColor}`}
          >
            {
              MODEL_ICONS[
                providerIconIndexMapping[
                  selectedModel.split(' - ')[0].toLowerCase()
                ]
              ]
            }
            {selectedModel || 'Select a Model'}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className={`border ${bgColor}`}>
          {Object.entries(models).map(([company, modelList], index) => (
            <DropdownMenuSub key={company}>
              <DropdownMenuSubTrigger
                className={`${hoverBgColor} ${hoverTextColor}`}
              >
                {MODEL_ICONS[index]}
                {company}
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent className={`border ${bgColor}`}>
                {modelList.map((model) => (
                  <DropdownMenuItem
                    key={model}
                    onClick={() => setSelectedModel(`${company} - ${model}`)}
                    className={`${hoverBgColor} ${hoverTextColor}`}
                  >
                    {model}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default ModelSelector;